/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessImagesBody
 */
export interface UpdateBusinessImagesBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessImagesBody
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessImagesBody
     */
    headerImage?: string;
}

export function UpdateBusinessImagesBodyFromJSON(json: any): UpdateBusinessImagesBody {
    return UpdateBusinessImagesBodyFromJSONTyped(json, false);
}

export function UpdateBusinessImagesBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessImagesBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'headerImage': !exists(json, 'headerImage') ? undefined : json['headerImage'],
    };
}

export function UpdateBusinessImagesBodyToJSON(value?: UpdateBusinessImagesBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'icon': value.icon,
        'headerImage': value.headerImage,
    };
}


